<template>
  <HomeCard v-if="user">
    <CardHeader title="Thông tin tài khoản" icon="fas fa-user-circle"/>
    <el-row class="single-info">
      <el-col :span="12" class="label"> E-mail: </el-col>
      <el-col :span="12">
        <span class="value">
          {{ user.email }}
        </span>
      </el-col>
    </el-row>
    <el-row class="single-info">
      <el-col :span="12" class="label"> Loại tài khoản </el-col>
      <el-col :span="12">
        <span class="value">
          {{ user.subscription.plan.name }}
        </span>
      </el-col>
    </el-row>
    <el-row class="single-info">
      <el-col :span="12" class="label"> Ngày hết hạn </el-col>
      <el-col :span="12">
        <span class="value">
          {{ formatDate(user.subscription.to) }}
        </span>
      </el-col>
    </el-row>
    <el-row class="single-info">
      <el-col :span="12" class="label"> Ngày bắt đầu </el-col>
      <el-col :span="12">
        <span class="value">
          {{ formatDate(user.subscription.from) }}
        </span>
      </el-col>
    </el-row>
  </HomeCard>
</template>

<script>
import FAIcon from "@/components/common/FAIcon.vue"
import { mapState } from "vuex"
import { AUTHENTICATE_STORE } from "@/store/modules/AuthenticateStore.js"
import { formatDate, formatDateTime } from "@/helpers/timeHelper.js"
import CardHeader from '@/components/HomeComponents/CardHeader.vue'
import HomeCard from '@/components/HomeComponents/HomeCard.vue'
export default {
  name: "HomeInfoCard",
  components: {HomeCard, CardHeader, FAIcon },
  data() {
    return {
      formatDateTime,
      formatDate,
    }
  },
  computed: mapState({
    user: (state) => state[AUTHENTICATE_STORE].user,
  }),
}
</script>

<style lang="scss" scoped>
.label {
  font-size: 1.2rem;
}
.single-info {
  margin: 1rem 0;
}
.value {
  font-size: 1.2rem;
  font-weight: 500;
}
</style>
